<template>
  <footer class="text-center mt-auto">
    <p class="mt-3"><strong>Side Realms © {{ year }}</strong></p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
